export enum MeuDiarioTipoQuestEnum {
    radio = 'RADIO',
    text = 'TEXT',
    checkbox = 'CHECKBOX'
}